import { t } from "@/i18n-js/instance";
import { Tab } from "@circle-react-uikit/TabV2";
import { ContentEditor } from "./Content";
import { StylesEditor } from "./Styles";

export const AttachmentBlockEditor = () => (
  <Tab.Group className="!h-auto">
    <Tab.List className="border-primary gap-x-0 border-b px-6">
      <Tab wrapperClassName="w-full" className="w-full">
        {t("builder_ui.block_props_category.content")}
      </Tab>
      <Tab wrapperClassName="w-full" className="w-full">
        {t("builder_ui.block_props_category.design")}
      </Tab>
    </Tab.List>
    <Tab.Panels>
      <Tab.Panel>
        <ContentEditor />
      </Tab.Panel>
      <Tab.Panel>
        <StylesEditor />
      </Tab.Panel>
    </Tab.Panels>
  </Tab.Group>
);
